export default __webpack_public_path__ + "static/media/pic_7.ad61d391.JPG";